import React from 'react';

import { useReferralFlowContext } from '../../contexts/ReferralFlowContext';

import { CandidateInfo } from './CandidateInfo/CandidateInfo';
import { OpeningInfo } from './OpeningInfo/OpeningInfo';
import { PersonalInfo } from './PersonalInfo/PersonalInfo';
import { Review } from './Review/Review';

export const ReferralFlow = () => {
  const { currentStep } = useReferralFlowContext();

  switch (currentStep) {
    case 1:
      return <PersonalInfo />;
    case 2:
      return <CandidateInfo />;
    case 3:
      return <OpeningInfo />;
    case 4:
      return <Review />;
    default:
      return null;
  }
};
